import { render } from "./SampleInformationTabs.vue?vue&type=template&id=f680fb68&scoped=true"
import script from "./SampleInformationTabs.vue?vue&type=script&lang=js"
export * from "./SampleInformationTabs.vue?vue&type=script&lang=js"

import "./SampleInformationTabs.vue?vue&type=style&index=0&id=f680fb68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f680fb68"]])

export default __exports__